<template>
  <v-btn icon density="compact" variant="text" @click="toggleSwitch">
    <v-icon :color="value ? 'error' : 'success'" size="small">
      {{ value ? "fas fa-circle-xmark" : "fas fa-circle-check" }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "SwitchStatusBtnComp",
  props: {
    modelValue: {
      type: String,
      validator: (value) => {
        return ["active", "suspended"].includes(value);
      },
    },
  },
  emits: ["click"],
  computed: {
    value: {
      get() {
        return this.modelValue === "active";
      },
    },
  },
  methods: {
    toggleSwitch() {
      const newValue = this.value ? "suspended" : "active";
      this.$emit("click", newValue);
    },
  },
};
</script>
